module.exports = __webpack_public_path__ + "assets/mailbox.ed5d5749.svg";